import { initializeApp } from 'firebase/app'
import { getMessaging, getToken } from 'firebase/messaging'

const firebaseConfig = {
  apiKey: 'AIzaSyDjUCi3laocyFxGkxItiSVHWo9-Z6mLDXo',
  authDomain: 'go2train-4d7cd.firebaseapp.com',
  projectId: 'go2train-4d7cd',
  storageBucket: 'go2train-4d7cd.firebasestorage.app',
  messagingSenderId: '91885605070',
  appId: '1:91885605070:web:1996900176be7c95f8809f'
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)
export const messaging = getMessaging(app)

export const generateFcmToken = async () => {
  const permission = await Notification.requestPermission()
  if (permission === 'granted') {
    try {
      const registration = await navigator.serviceWorker.register(
        '/firebase-messaging-sw.js'
      )
      console.log('Service Worker Registered:', registration)

      const vapidKey =
        'BPajUL6BAexOJduZDgZtgCX2Finuji8DtKuXcZtrgEfJNc13vlu8tenppjyiwaQJksKOlmK46oYrgahk16Pguyw'

      const token = await getToken(messaging, {
        vapidKey: vapidKey,
        serviceWorkerRegistration: registration
      })
      return token
    } catch (error) {
      console.error('Error getting token:', error)
    }
  }
  return ''
}
